// Route: /courses/catalog — LEGACY redirect → /catalog.
//
// Каталог стал ПУБЛИЧНЫМ и переехал за пределы закрытого префикса `/courses`:
// `lib/protected-routes.ts` закрывает его целиком, и оставить витрину внутри
// значило бы держать публичный раздел на списке точечных исключений
// (`PUBLIC_EXCEPTION_PREFIXES`) — мина, где каждый новый вложенный роут по
// умолчанию оказывается публичным или закрытым не туда. Разбор — в шапке
// `routes/catalog.tsx`.
//
// Роут сохранён редиректом: на него ведут ссылки из писем, уведомлений,
// закладок и с двух легаси-редиректов (`/courses/templates`,
// `/study-plan/templates`). Все параметры фильтров переносятся один в один —
// пользователь по старой ссылке обязан увидеть тот же срез каталога.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	scope: z.enum(["catalog", "mine"]).optional(),
	area: z.string().optional(),
	purpose: z.string().optional(),
	origin: z.string().optional(),
	locale: z.string().optional(),
	exam: z.string().optional(),
	pricing: z.enum(["free", "paid"]).optional(),
	q: z.string().optional(),
	sort: z.enum(["popular", "new"]).optional(),
	preset: z.string().optional(),
});

export const Route = createFileRoute("/courses/catalog")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		// Поштучно, а не `search` целиком и уж тем более не `as never`: схемы
		// сегодня совпадают один в один, но каст снял бы проверку совместимости
		// навсегда, и первая же правка одной из сторон молча увела бы
		// пользователя «не на тот экран» по ссылке из письма (гейт
		// `routes/__tests__/redirect-search.test.ts`).
		throw redirect({
			to: "/catalog",
			search: {
				...(search.scope ? { scope: search.scope } : {}),
				...(search.area ? { area: search.area } : {}),
				...(search.purpose ? { purpose: search.purpose } : {}),
				...(search.origin ? { origin: search.origin } : {}),
				...(search.locale ? { locale: search.locale } : {}),
				...(search.exam ? { exam: search.exam } : {}),
				...(search.pricing ? { pricing: search.pricing } : {}),
				...(search.q ? { q: search.q } : {}),
				...(search.sort ? { sort: search.sort } : {}),
				...(search.preset ? { preset: search.preset } : {}),
			},
			replace: true,
		});
	},
});
